// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import config from "@/config"
// import server from './service'
import resource from 'vue-resource'
import Utils from './utils/index';
import { setToken, getToken } from '@/utils/util'

import Vant from 'vant';
import './assets/css/reset.css';
import './assets/css/number.css';
import './assets/alifonts/iconfont.css';
import 'vant/lib/index.css';
import './index.less';
import './assets/css/main.scss';
import 'view-design/dist/styles/iview.css';
import ViewUI from 'view-design';

import { Toast,Dialog } from 'vant';
import VueScroller from 'vue-scroller'
import echarts from 'echarts';
Vue.use(VueScroller)
Vue.use(Vant);
Vue.use(ViewUI);


Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;
Vue.prototype.$echarts = echarts;


//引入地图
import AMap from 'vue-amap'
Vue.use(AMap);
// import Vconsole from "vconsole"
// Vue.prototype.$vConsole = new Vconsole();
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


Vue.filter('formatDate', function(dateString, formatStr = 'YYYY-MM-DD HH:mm') {
    return Utils.formatDate(dateString,formatStr);
})


Vue.config.productionTip = false;
// Vue.prototype.$server = server;
Vue.prototype.$Utils = Utils;
Vue.use(resource);

Vue.prototype.formatNumber = function (num) {
    num += '';
    if (!num.includes('.')) num += '.';
    return num.replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
        return $1 + ',';
    }).replace(/\.$/, '');
};
Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

//移除数组内相同元素
Array.prototype.removeSameEle = function(){
    var arr= new Array();
    for(var i = 0; i < this.length; i++){
        if(arr.indexOf(this[i]) == -1){
            arr.push(this[i]);
        }
    }
    return arr;
}
const turnTo = (to, access, next) => {
    // console.log(to);
    if(!to.name){
        // 防止地址栏刷新动态路由跳转到401或404,先跳转到homeName
        router.replace(to)
    } else {
        next()
    }
}
const LOGIN_PAGE_NAME = 'login'
const homeName = config.projectName == 'fengChiTool'? 'homeByToolCabinet':'home'
const permitList = [LOGIN_PAGE_NAME, 'loginSuccess','forget','shopRegisterContract','shopRegisterBaseInfo','shopRegisterCompanyInfo',
    'shopRegisterShopSetting','chooseAddress','shopRegisterChecking','shopRegisterCheckError','shopRegisterShopType']
router.afterEach((to, from, next) => {
    console.info("---afterEach---")
    //标题更新
    if(to.meta.title){
        document.title = store.webTitle = to.meta.title //改APP标题用的
    }

    //是否显示头部标题
    try {
       // window.native.getApp();
        if ( window.native) {
            console.info("------window.native------")
            store.state.showHeader = true
        }else if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
            store.state.showHeader = true
        }else   if(ua.match(/MicroMessenger/i) == "micromessenger" ){
            console.info("------micromessenger------")
            store.state.showHeader = false
        }else{
            console.info("------Error------")
              throw 'Error';
        }

    }catch (e) {
        store.state.showHeader = !!to.meta.isShowHeader
    }
    //判断历史记录 用于app返回操作App.vue的back()
    let historyIndex = store.state.historyArr.length - 2
    historyIndex >= 0 &&to.path == store.state.historyArr[historyIndex] ? store.state.historyArr.splice(historyIndex+1,1) : store.state.historyArr.push(to.path)

});
router.beforeEach((to, from, next) => {


    try {
        //window.native.getApp();
        var ua = window.navigator.userAgent.toLowerCase();
        if (window.native) {
            // //微信环境下
            // wx.miniProgram.getEnv(function (res) {
            //     if (res.miniprogram) {
            //         // 小程序环境下逻辑
            //         console.og("小程序环境下")
            //     } else {
            //         //非小程序环境下逻辑
            //         console.log("非小程序环境下")
            //     }
            // });
        }else{
            throw 'Error';
        }

        next();
    }
    catch (e) {
        console.info(e)
        const token = getToken()
        // next();
        // return
        if (!token && !permitList.includes(to.name)) {
            //未登录
            next({
                name: LOGIN_PAGE_NAME // 跳转到登录页
            })
            // next() // 跳转
        } else if (!token && permitList.includes(to.name)) {
            next() // 跳转
        }else if (token && to.name === LOGIN_PAGE_NAME) {
            // 已登录且要跳转的页面是登录页
            console.log(config.projectName)
            console.log(homeName)
            next({
                name: homeName // 跳转到homeName页
            })
        } else {
            if (store.state.user.hasGetInfo) {
                turnTo(to, store.state.user.access, next)
            } else {
                store.dispatch('getUserInfo').then(res => {
                    turnTo(to, store.state.user.access, next)
                }).catch(err => {
                    setToken('')
                    next({
                        name: 'login'
                    })
                })
            }
        }
    }

});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>',
})




// WEBPACK FOOTER //
// ./src/main.js